import client from "./clients/portalClient";

const getAllProducts = () => client.get(`/products`);
const getProduct = (id) => client.get(`/products/${id}`);
const postNewProduct = (data) => client.post(`/products`, data);
const editExistingProduct = (id, data) => client.put(`/products/${id}`, data);
const deleteProduct = (id) => client.delete(`/products/${id}`);

const getAllProductOrders = () => client.get(`/product_orders`);
const getProductOrder = (id) => client.get(`/product_orders/${id}`);
const postNewProductOrder = (data) => client.post(`/product_orders`, data);
const editExistingProductOrder = (id, data) => client.put(`/product_orders/${id}`, data);
const deleteProductOrder = (id) => client.delete(`/product_orders/${id}`);
const getAllProductOrderDetails = (id) => client.get(`/product_orders/${id}/details`);

const getProductOrderDetail = (id) => client.get(`/product_order_detail/${id}`);
const postNewProductOrderDetail = (data) => client.post(`/product_order_detail`, data);
const editExistingProductOrderDetail = (id, data) => client.put(`/product_order_detail/${id}`, data);
const deleteProductOrderDetail = (id) => client.delete(`/product_order_detail/${id}`);

const getProductOrderMessages = (id) => client.get(`/product_orders/${id}/comments`);
const postProductOrderMessages = (id,data) => client.post(`/product_orders/${id}/comments`, data);
const deleteProductOrderMessages = (id, sId) => client.delete(`/product_orders/${id}/comments/${sId}`);


const productsApi = {
    getAllProducts,
    getProduct,
    postNewProduct,
    editExistingProduct,
    deleteProduct,

    getAllProductOrders,
    getProductOrder,
    postNewProductOrder,
    editExistingProductOrder,
    deleteProductOrder,

    getAllProductOrderDetails,
    getProductOrderDetail,
    postNewProductOrderDetail,
    editExistingProductOrderDetail,
    deleteProductOrderDetail,

    getProductOrderMessages,
    postProductOrderMessages,
    deleteProductOrderMessages,
};

export default productsApi;
